export default __webpack_public_path__ + "static/media/error.41dd7156.png";